import { NavLink, Outlet } from "react-router-dom";
import { Logo } from "../components/Logo";
import { SessionChip } from "../components/SessionChip";
import { WorkspaceSwitcher } from "../components/WorkspaceSwitcher";

export function AppLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b border-border bg-white">
        <div className="max-w-6xl mx-auto px-6 py-3">
          {/* Row 1: brand + session. Nav lives here on desktop. */}
          <div className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-3 min-w-0">
              <NavLink to="/app" className="shrink-0"><Logo /></NavLink>
              {/* Switcher shows on desktop next to the logo, hides on mobile
                  (where it moves to its own row below to avoid crowding). */}
              <div className="hidden sm:block">
                <WorkspaceSwitcher />
              </div>
            </div>

            <nav className="hidden sm:flex items-center gap-2">
              <NavLink to="/app" end className={({ isActive }) =>
                `px-3 py-2 text-sm rounded-md transition-colors ${isActive ? "text-aigentico-navy font-semibold" : "text-ink-soft hover:text-ink"}`}>
                Evidence
              </NavLink>
              <NavLink to="/app/upload" className={({ isActive }) =>
                `px-3 py-2 text-sm rounded-md transition-colors ${isActive ? "text-aigentico-navy font-semibold" : "text-ink-soft hover:text-ink"}`}>
                Capture
              </NavLink>
            </nav>

            <div className="flex items-center gap-3 shrink-0">
              <SessionChip />
            </div>
          </div>

          {/* Row 2: mobile-only. Switcher on the left, nav on the right, both
              wrapping cleanly under the brand row. */}
          <div className="mt-3 flex sm:hidden items-center justify-between gap-3">
            <div className="min-w-0 flex-1">
              <WorkspaceSwitcher />
            </div>
            <nav className="flex items-center gap-1 shrink-0">
              <NavLink to="/app" end className={({ isActive }) =>
                `px-2 py-1.5 text-sm rounded-md transition-colors ${isActive ? "text-aigentico-navy font-semibold" : "text-ink-soft hover:text-ink"}`}>
                Evidence
              </NavLink>
              <NavLink to="/app/upload" className={({ isActive }) =>
                `px-2 py-1.5 text-sm rounded-md transition-colors ${isActive ? "text-aigentico-navy font-semibold" : "text-ink-soft hover:text-ink"}`}>
                Capture
              </NavLink>
            </nav>
          </div>
        </div>
      </header>

      <main className="flex-1">
        <div className="max-w-6xl mx-auto px-6 py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
